/**
 * 사용자 인증 관련 상태관리 모듈
 * 로그인, 로그아웃, 회원가입 등에서 발생하는 상태 데이터들이 저장되고 관리된다
 */

import { USER } from '../mutation-types';

import AuthService from '@/service/AuthService';
import MenuService from '@/service/cm/MenuService';

const authService = new AuthService();
const menuService = new MenuService();

export default {
    namespaced: true,

    // initial state
    state : {
        user : null,
        token: null,
        isAuthenticated: null,
        password: null,
        menuList: []
    },

    getters : {
        currentUser: (state) => {
            return state.user;
        },
        token: (state) => {
            return state.token;
        },
        isAuthenticated: (state) => {
            return state.isAuthenticated;
        },
        menuList: (state) => {
            return state.menuList;
        },
    },

    mutations : {
        loginSuccess (state, user) {
            state.user = user;
            state.token = user.token;
            state.isAuthenticated = true;
        },
        loginFailure (state) {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
        },
        logout (state) {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
            state.menuList = null;
        },
        registerSuccess (state) {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
        },
        registerFailure (state) {
            state.user = null;
            state.token = null;
            state.isAuthenticated = false;
        },
        [USER.SET_PASSWORD](state, value) {
            state.password = value;
        },
        setMenuList (state, list) {
            state.menuList = list;
        }
    },

    actions : {
        login ({ commit }, user) {

            return authService.login(user).then(
                res => {
                    let user = res.data;
                    if(user != undefined) {
                        if(!user.useYn || user.lockedYn) return false;  // 사용여부 false 또는 계정잠금여부 true인 경우

                        localStorage.setItem('user', JSON.stringify(user));
                        localStorage.setItem('token', user.token);

                        //alert('# auth.js : user.username = ' + user.username);
                        // 메뉴 목록을 가져와서 넣는다
                        menuService.getMine(user.username).then(data => {
                            //alert("# auth.js : user.username = " + user.username + " data = " + JSON.stringify(data));
                            commit('setMenuList', data);
                        });

                        commit('loginSuccess', user);
                        return Promise.resolve(user);
                    }
                    else {
                        //alert('#2 user is undefined');
                        return false;
                    }
                },
                error => {
                    commit('loginFailure');
                    return Promise.reject(error.response.data);
                }
            )
        },
        logout({ commit }) {
            localStorage.removeItem("user");
            localStorage.removeItem("token");
            commit('logout');
        },
        register({ commit }, user) {
            return authService.register(user).then(
                response => {
                    commit('registerSuccess');
                    return Promise.resolve(response.data);
                },
                error => {
                    commit('registerFailure');
                    return Promise.reject(error.response.data);
                }
            )
        },
        changePassword( {commit}, value ) {
            commit(USER.SET_PASSWORD, value);
        }
    }
}